import { useMemo } from 'react'
import ModalProvider from 'mui-modal-provider'

import CssBaseline from '@mui/material/CssBaseline'
import { createTheme, responsiveFontSizes, StyledEngineProvider, ThemeProvider as ThemeProviderMUI } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'

import AppVersionWatcher from '@shared/components/src/AppVersionWatcher'

import useFormatMessage from '@hooks/useFormatMessage'
import Toaster from '@components/Toast'

import { baseTheme } from '../../theme/baseTheme'
import { lightTheme } from '../../theme/lightTheme'

export default function ThemeProvider({ children }) {
  const formatMessage = useFormatMessage()

  const theme = useMemo(() => {
    let theme = createTheme(baseTheme(), lightTheme())
    theme = responsiveFontSizes(theme)
    return theme
  }, [])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StyledEngineProvider injectFirst>
        <ThemeProviderMUI theme={theme}>
          <CssBaseline />
          <Toaster />
          <AppVersionWatcher
            updatedMessage={formatMessage('appUpdated.toast')}
            staleMessage={formatMessage('appUpdated.available')}
            reloadLabel={formatMessage('common.reload')}
          />
          <ModalProvider>{children}</ModalProvider>
        </ThemeProviderMUI>
      </StyledEngineProvider>
    </LocalizationProvider>
  )
}
